// extracted by css-extract-rspack-plugin
export default {"container":"StaffToolsMenu-module__container__IXEtz","inlineContainer":"StaffToolsMenu-module__inlineContainer__EOT_z","inlineButton":"StaffToolsMenu-module__inlineButton__NO1NW"};